<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Immagine prodotto</h1>
<div mat-dialog-content>
    <div class="delivery-colle-data-box">
        <fieldset>
            <legend>Immagine prodotto</legend>
            <div class="col-48 grid-element-full img-container-modal">
                <div>
                    <a style="cursor: pointer;">
                        <img class="product-image" *ngIf="product?.product?.image" [src]="product?.product?.image" alt="" (click)="openImage(product?.product?.image)">
                        <img class="product-image" *ngIf="product?.product?.image === null || product?.product?.image === undefined " src="./assets/img/no-image.jpg" alt="" (click)="openImage('./assets/img/no-image.jpg')">
                    </a>
                </div>
            </div>
        </fieldset>
    </div>
</div>
<div mat-dialog-actions>
    <div>
        <button mat-button mat-dialog-close class="btn">Chiudi</button>
    </div>
</div>
